import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Scheduling Module Service Stores
 */
export const schedulingStores: ServiceStoreConfig[] = [
  {
    name: "scheduling-day",
    options: { enableStorage: true, enableErrorNotifications: false },
  },
  {
    name: "dates/holidays",
    options: { enableStorage: true, enableErrorNotifications: false },
  },
  {
    name: "schedule-generator",
    options: { enableStorage: false, enableErrorNotifications: false },
  },
  {
    name: "production-schedules",
    options: { enableStorage: true, enableErrorNotifications: false },
  },
  {
    name: "scheduling-sales-orders",
    options: { enableStorage: true, enableErrorNotifications: false },
  },
];